<template>
  <div class="main">
    <van-nav-bar title="资金详情" left-arrow @click-left="onClickLeft" />
    <van-pull-refresh v-model="loading" @refresh="onRefresh">

      <div class="container">
        <div class="top">
          <div class="left">
            <p class="title">{{ activeData.wyqymc }}</p>

            <div class="hoster">
              <div class="hostertop">
                <span>业主：</span><span style="font-weight: 400">{{ activeData.yz }}</span>
              </div>
              <div class="zhye">
                <span>账户余额：</span>
                <span style="font-weight: 550">￥ {{ activeData.zhye || 0 }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="right">
            <div class="images">
              <img class="images" src="../../assets/img/img_money_detail.png" />
            </div>
          </div> -->
        </div>
        <div class="content">
          <p class="vote-time" style="margin: 0">房屋地址：</p>
          <p class="text">
            {{ activeData.fwdz }}
          </p>
          <p class="vote-time">资金状态</p>
          <div class="btn">
            <div class="left">
              <span v-if="activeData.zhzt == 2" style="color: #00c797; font-size: 14px; font-weight: 500">{{
                activeData.zhzt | zhztMsg
              }}</span>
              <span v-if="activeData.zhzt == 1" style="color: #ff6c1a; font-size: 14px; font-weight: 500">{{
                activeData.zhzt | zhztMsg
              }}</span>
              <span v-if="activeData.zhzt == 3" style="color: red; font-size: 14px; font-weight: 500">{{
                activeData.zhzt | zhztMsg
              }}</span>
              <div class="right"></div>
            </div>
            <div class="right">
              <div class="status" v-if="activeData.zhzt == 1" @click="handlerPay">去交存</div>
            </div>
          </div>

          <div class="moneybox">
            <div class="top-money">
              <div class="left">
                <p class="money-title">总使用金额</p>
                <p class="money-total">￥{{ activeData.zsyje }}</p>
              </div>
              <div class="right" style="border-right: none">
                <p class="money-title">总增值收益</p>
                <p class="money-total">￥{{ activeData.zzzsy }}</p>
              </div>
            </div>
            <div class="top-money" style="border-bottom: 1px solid #e9e9e9">
              <div class="left">
                <p class="money-title">总交存金额</p>
                <p class="money-total">￥{{ activeData.zjcje }}</p>
              </div>
              <div class="right" style="border-right: none">
                <p class="money-title">账户余额</p>
                <p class="money-total">￥{{ activeData.zhye }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 资金明细 -->
        <div class="money-detail">
          <div class="detail-title">
            <img class="icon-img" src="../../assets/img/img_title.png" alt="" />
            <span class="img-title">资金明细</span>
          </div>
          <div class="detail-content">
            <div class="tabs">
              <div class="left" ref="tabsleft" @click="handlerClick(1)">
                交存金额
              </div>
              <div class="middle" ref="tabsmiddle" @click="handlerClick(2)">
                增值收益
              </div>
              <div class="right" ref="tabsright" @click="handlerClick(3)">
                资金使用
              </div>
            </div>
            <div class="biaoti">
              <div class="biaoti-left">
                <p style="margin-left:10px">{{ theme }}</p>
              </div>
              <div class="biaoti-right">
                <yearSelect ref="year" :year="year" @confirm="confirm"></yearSelect>

              </div>
            </div>

            <div style="margin-top: 20px" v-if="active == 1">
              <div v-if="loading" style="width: 100%; height: 40%;text-align: center;">
                <van-loading size="30px">加载中...</van-loading>
              </div>
              <div v-if="!loading">
                <div class="item" v-for="(item, index) in jcList" :key="index">
                  <div class="border-left"></div>
                  <div class="item-title">
                    <div class="circle">
                      <div class="son"></div>
                    </div>
                    <span>交存时间：{{ item.sj }}</span>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <p style="margin: 0;font-size: 13px;font-weight: 500;
                      color: #6b6a6a;
                      line-height: 14px;
                    ">
                        交存金额
                      </p>
                      <p style="
                      margin: 10px 0;
                      font-size: 16px;
                      font-weight: 600;
                      line-height: 19px;
                      color: #222120;
                    ">
                        ￥{{ item.je }}
                      </p>
                    </div>
                    <div class="info">
                      <p style="margin-top: 0">交存人：{{ item.jcr }}</p>
                      <p>交存银行：{{ item.jcyh }}</p>
                      <p>交存标准：￥{{ item.jcbz }}</p>
                      <p style="margin-bottom:0">当前账户余额：￥{{ item.zhye }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="!jcList.length && !loading" style="margin-left: 20px;color:#4e4d4d;font-size: 14px;">暂无数据
                </div>
              </div>


            </div>
            <div style="margin-top: 20px" v-if="active == 2">
              <div v-if="loading" style=" width: 100%;height: 40%;text-align: center; ">
                <van-loading size="30px">加载中...</van-loading>
              </div>
              <div class="item" v-for="(item, index)  in jcList" :key="index">
                <div class="border-left"></div>

                <div class="item-title">
                  <div class="circle">
                    <div class="son"></div>
                  </div>

                  <span>增值时间：{{ item.sj }}</span>
                </div>
                <div class="card">
                  <div class="card-shouyi">
                    <div class="card-left">
                      <p style="margin: 0;font-size: 13px;
                        font-weight: 500;
                        color: #6b6a6a;
                        line-height: 14px;
                      ">
                        增值金额
                      </p>
                      <p style="
                        margin: 10px 0;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 19px;
                        color: #222120;
                      ">
                        ￥{{ item.je }}
                      </p>
                    </div>

                  </div>
                  <div class="info">
                    <p style="margin-top: 0">维修资金总金额：￥{{ item.wxzjzje }}</p>
                    <p style="margin-bottom:0">当前账户余额：￥{{ item.zhye }}</p>
                  </div>
                </div>
              </div>
              <div v-if="!jcList.length && !loading" style="margin-left: 20px;color:#4e4d4d;font-size: 14px;">暂无数据</div>
            </div>
            <div style="margin-top: 20px" v-if="active == 3">
              <div v-if="loading" style="
            width: 100%;
            height: 40%;
            text-align: center;
          ">
                <van-loading size="30px">加载中...</van-loading>
              </div>
              <div class="item" v-for="(item, index) in jcList" :key="index">
                <div class="border-left"></div>

                <div class="item-title">
                  <div class="circle">
                    <div class="son"></div>
                  </div>
                  <span>使用时间：{{ item.sj }}</span>
                </div>
                <div class="card">
                  <div class="card-header">
                    <p style=" margin: 0;
                      font-size: 13px;
                      font-weight: 500;
                      color: #6b6a6a;
                      line-height: 14px;
                    ">
                      使用金额
                    </p>
                    <p style="
                      margin: 10px 0;
                      font-size: 16px;
                      font-weight: 600;
                      line-height: 19px;
                      color: #222120;
                    ">
                      ￥{{ item.je }}
                    </p>
                  </div>
                  <div class="info">
                    <p style="margin-top: 0;">维修资金使用项目：{{ item.wxzjsyxm }}</p>
                    <p>项目紧急程度：{{ item.jjcd }}</p>
                    <p>施工团队：{{ item.sgtd }}</p>
                    <p style="margin-bottom:0">当前账户余额：￥{{ item.zhye }}</p>
                  </div>
                </div>
              </div>
              <div v-if="!jcList.length && !loading" style="margin-left: 20px;color:#4e4d4d;font-size: 14px;">暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

  </div>
</template>
<script>
import api from "@/api/query.js";
import yearSelect from '../years/index.vue'
export default {
  name: "",
  components: {
    yearSelect
  },
  data() {
    return {
      active: 1,
      year: '',
      theme: "交存金额",
      yearColumns: [],
      activeId: "",
      activeData: {},
      jcList: [
        {
          sj: 2021
        }
      ],
      loading: false,
    };
  },
  filters: {
    zhztMsg(val) {
      switch (val) {
        case 1:
          return "未交";
        case 2:
          return "正常";
        case 3:
          return "余额不足";
      }
    },
  },
  created() {
    this.year = String(new Date().getFullYear())
  },
  mounted() {
    this.activeId = this.$route.query.fhid;
    this.getDetail();
    this.fundDetail()

  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    },
    getDetail() {
      api
        .fundDetails(this.activeId)
        .then((res) => {
          if (res.data.code == 200) {
            this.activeData = res.data.data;
            this.fundDetail()
          }
        })
        .catch((err) => { });
    },
    onRefresh() {
      this.getDetail()
    },
    // 资金明细
    fundDetail() {
      this.loading = true
      let params = {
        date: this.year,
        fhid: this.activeId,
        lx: this.active
      }
      api.getDetailed(params).then(res => {
        if (res.data.code == 200) {
          this.loading = false
          this.jcList = res.data.data
        } else {
          this.$toast.fail({
            message: '操作失败',
          })
          this.loading = false

        }

      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
        this.loading = false

      })
    },
    confirm(val) {
      this.year = String(val)
      this.fundDetail()
    },
    handlerClick(val) {

      this.active = val;
      this.jcList = []
      this.fundDetail()
      let left = this.$refs.tabsleft;
      let middle = this.$refs.tabsmiddle;
      let right = this.$refs.tabsright;
      if (val == 1) {
        this.theme = '交存金额'
        left.style.backgroundColor = "#fff";
        left.style.color = "#ff6c1a";
        middle.style.backgroundColor = "#f4f7f9";
        middle.style.color = "#4e4d4d";
        right.style.backgroundColor = "#f4f7f9";
        right.style.color = "#4e4d4d";
      } else if (val == 2) {
        this.theme = '增值收益'
        middle.style.backgroundColor = "#fff";
        middle.style.color = "#ff6c1a";
        left.style.backgroundColor = "#f4f7f9";
        left.style.color = "#4e4d4d";
        right.style.backgroundColor = "#f4f7f9";
        right.style.color = "#4e4d4d";
      } else {
        this.theme = '资金使用'
        right.style.backgroundColor = "#fff";
        right.style.color = "#ff6c1a";
        left.style.backgroundColor = "#f4f7f9";
        left.style.color = "#4e4d4d";
        middle.style.backgroundColor = "#f4f7f9";
        middle.style.color = "#4e4d4d";
      }
    },
    handlerPay() {
      location.href = 'saveDetail' + '?id=' + this.$route.query.tzdid
      // this.$router.push({ path: 'saveDetail', query: { id: this.$route.query.tzdid } })

    },

  },
};
</script>

<style lang="less" scoped>
.van-nav-bar {
  position: sticky;
  top: 0;
  z-index: 999;

}

.text {
  min-height: 16px;
  line-height: 16px;
}

.main {
  min-height: 100%;

  background: linear-gradient(180deg,
      rgba(255, 216, 193, 0.42) 0%,
      rgba(244, 247, 249, 0.4) 100%);

  .container {
    padding: 20px;
    height: 100%;
    position: relative;


    .top {
      display: flex;
      width: 100%;
      min-height: 120px;
      overflow: hidden;
      padding-bottom: 20px;


      .left {
        flex: 3;
        width: 60%;

        .title {
          width: 335px;
          min-height: 30px;
          margin: 0;
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #222120;
          line-height: 30px;
          position: relative;
          z-index: 9;
        }

        .hoster {
          margin-top: 20px;
          width: 100%;
          min-height: 50px;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          font-size: 14px;
          font-weight: 520;
          color: #222120;

          .hostertop {
            width: 100%;
            min-height: 14px;
            font-size: 14px;
            font-weight: 550;
            color: #222120;
            line-height: 16px;
            position: relative;
            z-index: 9
          }

          .zhye {
            width: 100%;
            margin-top: 10px;
            position: relative;
            z-index: 9
          }
        }
      }

      .right {
        position: relative;
        flex: 1;
        width: 40%;

        // margin-top: 20px;
        .images {
          position: absolute;
          z-index: -9;
          right: 0px;
          width: 120px;
          height: 120px;
          background: transparent;
        }
      }
    }

    .content {
      width: 100%;
      min-height: 370px;
      background: #ffffff;
      padding: 16px;
      position: relative;

      &::after {
        content: "";
        display: inline-block;
        position: absolute;
        right: 0px;
        top: -94px;
        width: 120px;
        height: 120px;
        background: url("../../assets/img/img_money_detail.png");
        background-size: 120px 120px;
        z-index: 1;
      }

      .vote-time {
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #4e4d4d;
        line-height: 19px;
      }

      .text {
        width: 100%;
        min-height: 16px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 18px;
      }

      .btn {
        display: flex;
        width: 100%;
        height: 28px;
        align-items: center;
        justify-content: space-between;

        .left {
          min-width: 28px;
        }

        .right {
          min-width: 68px;

          .status {
            width: 62px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            color: #ff6c1a;
            font-size: 14px;
            border-radius: 14px 14px 14px 14px;
            opacity: 1;
            border: 1px solid #ff6c1a;
          }
        }
      }

      .moneybox {
        margin-top: 20px;
        width: 100%;
        height: 174px;
        background: #ffffff;

        .top-money {
          display: flex;
          width: 100%;
          height: 50%;
          border-top: 1px solid #e9e9e9;



          .left {
            padding-left: 16px;
            width: 50%;
            height: 100%;
            border-right: 1px solid #e9e9e9;

            .money-title {
              font-size: 14px;
              color: #999998;
              line-height: 16px;
              margin: 20px 0 6px 0;
            }

            .money-total {
              width: 100%;
              margin: 0;
              height: 30px;
              font-size: 16px;
              font-weight: 600;
              color: #4e4d4d;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

            }
          }

          .right {
            height: 100%;
            padding-left: 16px;
            width: 50%;
            border-right: 1px solid #e9e9e9;

            .money-title {
              font-size: 14px;
              color: #999998;
              line-height: 16px;
              margin: 20px 0 6px 0;
            }

            .money-total {
              width: 100%;
              margin: 0;
              height: 30px;
              font-size: 16px;
              font-weight: 600;
              color: #4e4d4d;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

            }
          }
        }
      }
    }

    .money-detail {
      // height: 25px;
      margin-top: 30px;
      width: 100%;

      .detail-content {
        width: 100%;

        .item {
          position: relative;
          min-height: 140px;

          .card {
            // width: 100%;
            min-height: 140px;
            margin: 16px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            box-shadow: 0px 0px 0px 1px #eee;

            .card-header {
              width: 100%;
              height: 63px;
              padding: 10px 16px;
              border-bottom: 1px solid #e9e9e9;
            }

            .card-shouyi {
              display: flex;
              width: 100%;
              height: 63px;
              padding: 10px 16px;
              border-bottom: 1px solid #e9e9e9;

              .card-left {
                flex: 2;
              }

              .card-right {
                flex: 2;
              }
            }

            .info {
              width: 100%;
              min-height: 20px;
              padding: 16px;
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4d4d;
              line-height: 16px;
            }
          }

          .border-left {
            position: absolute;
            top: 12px;
            left: 3px;
            height: 100%;
            width: 1px;
            border-left: 1px dashed #e9e9e9;
          }
        }
      }

      .icon-img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }

      .detail-title {
        font-size: 18px;
        font-weight: 700;
        color: #222120;
      }
    }
  }
}

.biaoti {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;

  .biaoti-left {
    width: 100px;

    font-weight: 500;
    height: 22px;
    line-height: 19px;
    color: #222120;

    font-size: 16px;
  }

  .biaoti-right {
    width: 104px;

    height: 36px;
    background: #FFFFFF;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #E9E9E9;
  }
}


.item-title {
  height: 17px;
  width: 100%;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #999998;
  line-height: 14px;

  .circle {
    position: relative;
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #999998;
    border-radius: 50%;
    margin-right: 4px;

    .son {
      position: absolute;
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #fff;
      top: 2px;
      left: 2px;
    }
  }
}

.tabs {
  display: flex;
  height: 40px;
  text-align: center;
  line-height: 40px;

  font-weight: 500;
  color: #4e4d4d;
  margin-top: 16px;
  background-color: #f4f7f9;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #e9e9e9;

  .active {
    background-color: #fff;
    color: #ff6c1a;
  }

  .left {
    flex: 1;
    height: 100%;
    background-color: #fff;
    color: #ff6c1a;
    border-radius: 20px 0px 0px 20px;
    border-right: 1px solid #e9e9e9;
  }

  .middle {
    flex: 1;
    height: 100%;
    border-right: 1px solid #e9e9e9;
  }

  .right {
    flex: 1;
    height: 100%;
    border-radius: 0px 20px 20px 0px;
  }

  .leftcontent .middlecontent .rightcontent {
    width: 100%;
    margin-top: 20px !important;
  }
}



/deep/.van-tabs__wrap {
  margin-top: 20px;
  //   height: 0;
}

/deep/ .van-tabs__nav {
  height: 40px;
  color: #4e4d4d;
  font-family: PingFang SC-Medium, PingFang SC;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #999998;
  margin-bottom: 20px;
  margin: 0 0 20px 0;
}

/deep/.van-tabs--card>.van-tabs__wrap {
  height: 100%;
}

/deep/ .van-tabs__nav :nth-child(1) {
  border-radius: 20px 0px 0px 20px;
  background-color: #fff;
  color: #ff6c1a;
}

/deep/ .van-tabs__nav :nth-child(3) {
  border-radius: 0px 20px 20px 0px;
  background-color: #fff;
  color: #ff6c1a;
}

/deep/ .van-tab--activ {
  color: #ff6c1a;
  font-weight: 600;
  font-size: 14px;
}

/deep/.van-field__label {
  width: 4.2em;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-cell__title {
  text-align: center;
}

/deep/ .van-cell__value {
  text-align: left;
}

/deep/ .van-dropdown-item__content {
  top: 2px;
  max-height: 100% !important;
  box-shadow: 0 2px 12px rgb(100 101 102 / 12%);
}

// /deep/ .van-overlay {
//   background-color: #fff;
//   opacity: 0;
// }

/deep/ .van-cell {
  // background-color: #f4f7f9;
  padding: 10px 0;
}

// /deep/ van-dropdown-menu__title--active {
//   color: #ff6c1a;
// }

// /deep/ .van-dropdown-item__option--active {
//   color: #ff6c1a;
// }

// /deep/ .van-tabs__content {
//   width: 100%;
//   min-height: 230px;
//   margin-bottom: 20px;
// }
</style>
